<template>
  <div>
    <div class="body_head">
      <div class="head_left" @click="resourceInfo">
        <div class="showCard-imgBox">
          <div style="    position: relative;">
            <img :src="productObj.imageUrl" alt="">
            <b class="tag" v-if="showTag">专属</b>
          </div>
        </div>
        <div class="head_center">
          <div class="resourceNameCn">
            <span class="name" @click.stop="goToResourceDetail(productObj)">{{ productObj.nameCn }}</span><span
              v-if="productObj.nameCn != productObj.nameEn">{{ productObj.nameEn }}</span>
            <span v-if="productObj.state == 6" class="label">{{ '内含' + productObj.stockListResults.length + '个签证产品' }}</span>
            <span v-if="productObj.star"><i class="el-icon-star-on" v-for="item in productObj.star"
                :key="item"></i></span>
            <div v-if="productObj.state == 2">
              <span v-if="productObj.otherResourceData.mainSpot == 1" class="spanCard">主景点</span>
              <span v-if="productObj.otherResourceData.mustGo == 1" class="spanCard">人气</span>
            </div>
          </div>
          <div class="icon" v-if="productObj.productType == 1">
            <svg-icon :iconClass="'fire'"></svg-icon>
            <span>使用次数：{{ productObj.useCount }}次</span>
          </div>
          <div class="labelContain" v-if="productObj.labels&&productObj.labels.length>0">
            <span class="label" v-for="(item,index) in productObj.labels" :key="index">{{item}}</span>
          </div>
          <div class="addressBox" v-if="productObj.addressCn != '' || productObj.address != ''">
            <i class="el-icon-location"></i>
            <span>{{ productObj.addressCn != '' ? productObj.addressCn : productObj.address }}</span>
          </div>
          <div class="spotBox" v-if="productObj.state == 2">
            <span>热度：{{ productObj.otherResourceData.usageRate }}%</span>
            <span>游玩：约{{ productObj.otherResourceData.playTime }}</span>
            <span>排名：1{{ productObj.otherResourceData.ranking }}</span>
          </div>
          <div class="addressBox" v-if="productObj.introduction && productObj.introduction != ''">
            <el-tooltip placement="top" popper-class="addressBoxTip">
              <div slot="content">{{ productObj.introduction }}</div>
              <span>{{ productObj.introduction }}</span>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="head_right" v-if="rightAction">
        <div v-if="rightShowStyle==2" class="head_right1">  
          <div class="cardContainer">
            <div class="cardContainer-oneBox" @click.stop>
              <span @click="openDirectPopup(productObj)" class="btn">{{ btnName }}</span>
              <div class="cardContainer-twoBox">
                <span class="circle" @click="addReferResource(productObj)">
                  <i class="el-icon-star-off"></i>
                </span>
                <span class="fractionBox">
                  <b>{{ productObj.score }}分</b>
                  <span>{{ productObj.productType == 3 ? '/5分' : '/10分' }}</span>
                </span>
              </div>
            </div>
          </div>
          <div class="showCard-tag">
            <div>
              <i @click.stop="openPriceDetail(productObj)"
                :class="productObj.isOpen ? 'el-icon-caret-top' : 'el-icon-caret-bottom'"></i>
            </div>
            <div>
              <b>{{ productObj.price }}</b>
              <b style="font-size:0.12rem;">{{ productObj.currency }}</b>
              <label>起</label>
            </div>
          </div>
        </div>
        <div v-if="rightShowStyle==1" class="head_right1">
          <div class="cardContainer">
            <div class="cardContainer-oneBox">
              <div class="circle">
                <i class="el-icon-star-off" @click="addReferBudget(productObj)"></i>
                <span class="btn" @click="exclusiveAddYsP(productObj)">{{ btnName }}</span>
              </div>
              <div class="cardContainer-twoBox">
                <p class="cirleXun" v-if="btnName1!=''" style="cursor: pointer;" @click="inquiryResource(productObj)">{{ btnName1 }}</p>
                <span class="fractionBox">
                  <b>{{ productObj.score }}分</b>
                  <span>{{ productObj.productType == 6 ? '/10分' : '/5分' }}</span>
                </span>
              </div>
            </div>
          </div>
          <div class="showCard-tag" @click="openPriceDetail()">
            <div>
              <i v-if="productObj.price != ''" :class="productObj.isOpen ? 'el-icon-caret-top' : 'el-icon-caret-bottom'"></i>
            </div>
            <div>
              <b>{{ productObj.price == '' ? priceNullStr : productObj.price }}</b>
              <b style="font-size:0.12rem;">{{ productObj.currency }}</b>
              <label v-if="(productObj.productType == 1 || productObj.productType == 3) && productObj.price != ''">起</label>
            </div>
          </div>
        </div>
      </div>
      <slot v-else name="headRight"></slot>
    </div>
    <add-refer-resource :resourceObj="productObj" ref="addReferResource"></add-refer-resource>
    <resource-detail ref="resourceDetail"></resource-detail>
    <directPopup ref="directPopup"></directPopup>
  </div>
</template>

<script>
import ResourceDetail from '../../../info/ResourceDetail.vue'
import addReferResource from './addReferResource.vue'
import directPopup from '../directPurchaseSpecialPrice/directPopup.vue'
export default {
  components: {
    addReferResource,
    ResourceDetail,
    directPopup
  },
  props: {
    productObj: {
      type: Object,
      default: () => { return {} }
    },
    showTag: {
      type: Boolean,
      default: true,
    },
    rightAction: {
      type: Boolean,
      default: true,//右边部分是否需要solt true 不需要
    },
    rightShowStyle: {
      type: Number,
      default: 1,//右边部分显示样式 1 带加入报价按钮 和 2 有询价按钮得样式
    },
    btnName: {
      type: String,
      default: '加入报价',//右边部分是否需要solt true 不需要
    },
    btnName1: {
      type: String,
      default: '抢',
    },
    budget: {
      type: Object,
      default: () => { return {} }
    },
    priceNullStr: {
      type: String,
      default: '暂无报价',
    }
  },
  methods: {
    //打开直采特价
    openDirectPopup(item) {
      this.$refs.directPopup.init(item)
    },
    goToResourceDetail(item) {
      this.$refs.resourceDetail.init(item)
    },
    inquiryResource(item) {
      this.$emit("inquiryResource", item)
    },
    exclusiveAddYsP() {
      this.$emit("exclusiveAddYsP")
    },
    addReferBudget() {
      this.$emit("addReferBudget")
    },
    openPriceDetail() {
      this.$set(this.productObj, 'isOpen', !this.productObj.isOpen)
      if (this.productObj.productType == 6 && this.productObj.stockListResults.length == 0) {
        this.$emit("getHotelPriceInfo", this.productObj)
      }
    },
    addReferResource() {
      this.$refs.addReferResource.beforeOpen(this.budget)
    },
    resourceInfo() {
      this.$emit("resourceInfo")
    }
  },
  mounted() {
  }
}
</script>
<style lang="scss" scoped>
.body_head {
  display: flex;
  border-bottom: 3px solid #db4e1a;
  justify-content: space-between;

  .head_left {
    display: flex;
    padding-bottom: 0.05rem;
    img {
      margin: 0 10px;
      width: 0.8rem;
      height: 0.8rem;
      object-fit: cover;
    }
    .showCard-imgBox {
      .tag {
        position: absolute;
        bottom: 0.1rem;
        right: 0.15rem;
        color: #fff;
        background: rgba(219, 78, 26, 0.7);
        display: inline-block;
        padding: 0.03rem 0.05rem;
        text-align: center;
      }
    }

    .head_center {
      .icon {
        margin-top: 0.05rem;
        display: flex;
        align-items: center;

        svg {
          height: 14px;
          width: 14px;
          margin-right: 0.1rem;
        }
      }

      .resourceNameCn {
        font-weight: bold;
        display: flex;
        flex-wrap: wrap;
        align-items: center;

        .spanCard {
          border: 1px solid #5d76f4;
          color: #5d76f4;
          padding: 0.01rem 0.03rem;
          margin-left: 0.05rem;
        }

        .name {
          margin-right: 10px;
          cursor: pointer;
        }

        .el-icon-star-on {
          color: #d51922;
        }
      } 
      .labelContain{
        margin-top: 0.1rem;
        display: flex;
        flex-wrap: wrap;
      }
      .addressBox {
        color: #a3adb8;
        padding-top: 5px;
        font-size: 0.12rem;
        display: flex;
        align-items: center;

        >span {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          width: 4.5rem;
          display: inline-block;
        }
      }

      .label {
        padding: 0.02rem 0.05rem;
        color: #fcca00;
        border: 1px solid #fcca00;
        font-weight: normal;
        margin-right: 0.05rem;
        margin-bottom: 0.05rem;
      }

      .spotBox {
        margin-top: 0.05rem;
        font-size: 0.12rem;

        >span {
          margin-right: 0.1rem;
          font-weight: bold;
        }

        >span:first-child {
          padding: 0.02rem 0.05rem;
          background: #db4e1a;
          color: #fff;
          font-size: 0.12rem;
          font-weight: normal;
        }
      }
    }
  }
  .head_right{
    display: flex;
    .head_right1{
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
    .cardContainer{
      background: #f1f4f4;
      width: 1.3rem;
    }

    .cardContainer-oneBox {
      padding: 0.05rem 0.1rem 0.05rem 0.05rem;
      text-align: center;

      .circle {
        display: flex;
        align-items: center;

        i {
          font-size: 0.2rem;
          color: #333;
          margin-right: 0.09rem;
        }
      }

      .btn {
        cursor: pointer;
        display: inline-block;
        background: var(--bottomBtnColor);
        color: #fff;
        padding: 0.03rem 0.05rem;
        font-size: 0.12rem;
        width: 1.2rem;
      }

      .cardContainer-twoBox {
        margin-top: 0.05rem;
        display: flex;
        align-items: center;

        .cirleXun {
          line-height: 0.24rem;
          text-align: center;
          border-radius: 50%;
          border: 1px solid #bbbbbb;
          background: #fff;
          margin: 2px 0;
          width: 0.24rem;
          color: red;
          font-weight: bold;
        }

        .fractionBox {
          >b {
            color: #d81b43;
            font-size: 0.16rem;
          }

          >span {
            font-weight: bold;
            color: #676976;
            font-size: 0.12rem;
          }
        }
      }
    }

    .showCard-tag {
      padding: 0 0.04rem;
      height: 0.35rem;
      background: #db4e1a;
      display: flex;
      align-items: center;
      margin-bottom: 0.01rem;
      justify-content: space-between;
      cursor: pointer;
      color: #fff;

      >div {
        >i {
          font-size: 0.25rem;
        }

        >b {
          font-size: 0.18rem;
        }

        >label {
          font-size: 0.12rem;
          padding-right: 3px;
        }
      }
    }
  }
}</style>